import React from 'react';
import { motion } from 'framer-motion';
import { useGentleMotion as useReducedMotion } from '../hooks/useGentleMotion';
import { useMarket } from '../contexts/MarketContext';
interface PriceBlockProps {
  /** 'responsive' centers on mobile and aligns left from lg up. */
  align?: 'left' | 'center' | 'responsive';
  size?: 'md' | 'lg';
}
export function DiscountBadge({
  className = '',
  size = 'md'
}: {
  className?: string;
  size?: 'md' | 'lg';
}) {
  const reduce = useReducedMotion();
  return <motion.span className={['relative inline-flex select-none items-center rounded-full bg-offer font-display font-extrabold uppercase tracking-wide text-white shadow-[0_8px_18px_-6px_rgba(232,69,60,0.7)]', size === 'lg' ? 'px-5 py-2.5 text-lg' : 'px-4 py-2 text-sm', className].join(' ')} style={{
    rotate: '-3deg',
    color: "#FFFFFF",
    backgroundColor: "#E8453C"
  }} animate={reduce ? undefined : {
    scale: [1, 1.06, 1]
  }} transition={{
    duration: 2.6,
    repeat: Infinity,
    ease: 'easeInOut'
  }} data-id="element-220" data-mp="1g5muh3dntwcw">
      50% OFF
    </motion.span>;
}
export function PriceBlock({
  align = 'left',
  size = 'md'
}: PriceBlockProps) {
  const {
    market
  } = useMarket();
  return <div className={['flex flex-wrap items-center gap-x-4 gap-y-3', align === 'center' ? 'justify-center' : '', align === 'responsive' ? 'justify-center lg:justify-start' : ''].join(' ')} data-id="element-221" data-mp="1wwhyi8zid6hs">
      <span className="font-sans text-base text-muted line-through decoration-offer decoration-[2.5px]" data-id="element-222" data-mp="191f83wl22uz7">
        {market.compareAt}
      </span>
      <span className={['font-display font-extrabold leading-none text-navy', size === 'lg' ? 'text-5xl sm:text-6xl' : 'text-4xl'].join(' ')} data-id="element-223" data-mp="1e08qa2bafa5p">
        {market.price}
      </span>
      <DiscountBadge size={size === 'lg' ? 'lg' : 'md'} data-id="element-224" data-mp="1myc226wh0skb" />
    </div>;
}